import { HttpResponse } from '@angular/common/http';

import * as saveAs from 'file-saver';

export const downloadFile = (data: Blob, fileName: string, type: string) => {
    const blob = new Blob([data], { type });
    saveAs(blob, fileName);
};

export const getFileNameAndExt = (fileName: string = '') => {
    return {
        fileName: fileName.substring(0, fileName.lastIndexOf('.')),
        fileExtension: fileName.substring(fileName.lastIndexOf('.'), fileName.length)
    };
};

export const downloadFileByName = (resp: HttpResponse<Blob>) => {
    const { body, headers } = resp;
    const contentDispositionHeader = headers.get('Content-Disposition');
    const fileNameMatch = contentDispositionHeader && contentDispositionHeader.match(/filename="(.+)"/);

    if (fileNameMatch && fileNameMatch.length === 2 && body) {
        const fileName = fileNameMatch[1];
        const url = window.URL.createObjectURL(body);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
    } else {
        console.error('Content disposition header not exposed:', contentDispositionHeader);
    }
};
